import { Suspense, lazy } from "react";
import { Outlet } from "react-router-dom";
import Loader from "@/components/Loader";
import DashboardLayout from "../layouts/dashboard";
import AuthGuard from "../guards/AuthGuard";
import RoleGuard from "../guards/RoleGuard";
import {
    PATH_TRAINING,
    PATH_TRAINING_WEEKLY_REPORT,
    PATH_TRAINING_AGENT_PROFILE,
} from "./paths";
import { getRelativePath } from "@/utils/paths";

const TrainingPage = lazy(() => import("@/pages/training/TrainingPage"));
const WeeklyReportPage = lazy(() => import("@/pages/training/WeeklyReportPage"));
const AgentProfilePage = lazy(() => import("@/pages/training/AgentProfilePage"));

const trainingRoutes = [
    {
        path: PATH_TRAINING,
        element: (
            <AuthGuard>
                <RoleGuard>
                    <DashboardLayout>
                        <Suspense fallback={<Loader />}>
                            <Outlet />
                        </Suspense>
                    </DashboardLayout>
                </RoleGuard>
            </AuthGuard>
        ),
        children: [
            {
                element: <TrainingPage />,
                index: true,
            },
            {
                path: getRelativePath(PATH_TRAINING, PATH_TRAINING_WEEKLY_REPORT),
                element: <WeeklyReportPage />,
            },
            {
                path: getRelativePath(PATH_TRAINING, PATH_TRAINING_AGENT_PROFILE),
                element: <AgentProfilePage />,
            },
        ],
    },
];

export default trainingRoutes;
